// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__29rcS","inputWrap":"styles_inputWrap__3QyYV","input":"styles_input__3YEXL"};